import React from 'react';

export default function CTASection() {
  return (
    <section className="cta-section" id="cta">
      <div className="cta-container">
        <span className="cta-tag">READY TO INVEST?</span>
        <h2 className="cta-title">Buy or Sell <span className="highlight-red">BGG</span> <span className="highlight-purple">Coin</span> Today</h2>
        <p className="cta-description">Join thousands of investors trading Tempes (BGG) — the next-generation AI-powered cryptocurrency. Start your journey now on our trusted exchange partner.</p>
        <a href="https://americanex1.com" target="_blank" rel="noopener noreferrer" className="cta-btn">
          Buy / Sell BGG Coin
          <i className="fa-solid fa-arrow-right"></i>
        </a>
      </div>
    </section>
  );
}
